// extracted by mini-css-extract-plugin
module.exports = {"editModal":"editModal__GysIm","input":"input__vYXnI","buttons":"buttons__K4PlZ"};